import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimComment.List.IRequest;
type Response = Api.Core.ClaimComment.List.IResponse;
type Headers = Api.Core.ClaimComment.List.IHeaders;
const url = '/api/Claims/ClaimComment';
export default async function claimCommentListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
